<div class="wrapper" [ngClass]="{ wide: wide, 'manual-size': isPreviewMode }">
  <youtube-player
    [playerVars]="{
      autoplay: 1,
      autohide: 1,
      mute: 1,
      playsinline: 1,
      loop: 1,
      controls: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      enablejsapi: 1,
      disablekb: 1,
    }"
    [videoId]="videoId"
    disableCookies
    (stateChange)="onReady($event)"
  />
  <div class="video-shade"></div>
</div>
